export const SET_PBX_EVENT = "SET_PBX_EVENT";

export const setPbxEvent = event => ({
  type: SET_PBX_EVENT,
  payload: event
}); 